import { render } from "./pickUpInfo.vue?vue&type=template&id=21d7f438"
import script from "./pickUpInfo.vue?vue&type=script&lang=js"
export * from "./pickUpInfo.vue?vue&type=script&lang=js"

import "./pickUpInfo.vue?vue&type=style&index=0&id=21d7f438&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__